import React from 'react';

const tones = {
  neutral: 'text-ink-muted hover:bg-surface-hover hover:text-ink',
  brand: 'text-brand-ink hover:bg-brand-subtle',
  success: 'text-success hover:bg-success-subtle',
  warning: 'text-warning hover:bg-warning-subtle',
  danger: 'text-danger hover:bg-danger-subtle',
};

const sizes = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8',
};

/**
 * Action compacte de ligne de tableau. `badge` affiche un compteur
 * (absences en attente, etc.).
 */
const IconButton = ({ icon, tone = 'neutral', size = 'md', badge = null, className = '', title, ...props }) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    className={`relative inline-flex items-center justify-center rounded-md border border-transparent transition-colors duration-150 disabled:opacity-40 disabled:pointer-events-none ${
      tones[tone] || tones.neutral
    } ${sizes[size] || sizes.md} ${className}`}
    {...props}
  >
    {icon}
    {badge != null && (
      <span className="absolute -top-1 -end-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-2xs font-semibold text-white">
        {badge}
      </span>
    )}
  </button>
);

export default IconButton;
